export const ACTUALIZAR_LIST_LEGAJOS = "ACTUALIZAR_LIST_LEGAJOS";
export const MODIFICAR_LEGAJO = "MODIFICAR_LEGAJO";
export const AGREGAR_LEGAJO = "AGREGAR_LEGAJO";  
export const ELIMINAR_LEGAJO = "ELIMINAR_LEGAJO";